import React from 'react';
import './styles.css'; // Import the styles.css file

const Home = () => {
  return (
    <div className="centered-content">
      <p> SkillDirector is seeking to make role-based competency model development easy and practical to build and maintain by leveraging new natural language processing (NLP), large language AI models.  After preliminary testing, it has been determined that the best technology for our application is ChatGPT.  </p>
    </div>
  );
};

export default Home;
